import { getPersonData } from "../utils/myinfoData";
import React, { useEffect, useState } from "react";
import { Progress, Button, Modal, message, Avatar, Collapse } from "antd";
import cookies from "js-cookie";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import Cookies from "js-cookie";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../assets/img/SL-01.png";
import boldFont from "../assets/font/Poppins-SemiBold.ttf";
import { format } from "date-fns";
import ProfileViewer from "../pages/borrower-dashboard/ProfileViewer";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: 700 }, // Bold (700)
  ],
});

const EmployeeSetup = () => {
  const [employeeList, setEmployeeList] = useState([]);
  const [createEmployeeModalIsOpen, setCreateEmployeeModalIsOpen] =
    useState(false);

  const [createRole, setCreateRole] = useState("employee");
  const [editingRoleEmployee, setEditingRoleEmployee] = useState(null);
  const [selectedRole, setSelectedRole] = useState("employee");
  const [passwordEmployee, setPasswordEmployee] = useState(null);
  const [passwordValue, setPasswordValue] = useState("");

  const [showingAccounts, setShowingAccounts] = useState(false);

  const [createForm, setCreateForm] = useState("");
  const [createEmail, setCreateEmail] = useState("");
  const [createMobileNo, setCreateMobileNo] = useState("");
  const [contactEmployee, setContactEmployee] = useState(null);
  const [contactEmail, setContactEmail] = useState("");
  const [contactMobileNo, setContactMobileNo] = useState("");
  const [clickedUser, setClickedUser] = useState(null);

  const [dataSingpassModal, setDataSingpassModal] = useState(false);
  const [needOtherAuthoriser, setNeedOtherAuthoriser] = useState(false);
  const [otherAuthoriserDetails, setOtherAuthoriserDetails] = useState(null);
  const [openDataIndex, setOpenDataIndex] = useState(null);
  const [keyman, setKeyman] = useState("");
  const [viewingUser, setViewingUser] = useState(0);
  const [viewingTab, setViewingTab] = useState(0);
  const [liveUserData, setLiveUserData] = useState(null);
  const [singpassData, setSingpassData] = useState(null);
  const [combinedSingpassData, setCombinedSingpassData] = useState([]);
  const [badgeVerified, setBadgeVerified] = useState(false);
  const [screenWidth, setScreenWidth] = useState(1920);
  const [allCBSData, setAllCBSData] = useState([]);
  const [backupContact, setBackupContact] = useState("");
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "dd MMMM yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  const availableTab = [
    { name: "Personal Information" },
    { name: "Corporate Information" },
    { name: "NOA History" },
    { name: "Capitals" },
    { name: "Financials" },
    { name: "Shareholders" },
    { name: "Borrower Report" },
  ];
  const singpassDetails = async (
    user,
    other_authorization,
    loan_id,
    keyman
  ) => {
    try {
      setKeyman(keyman);
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getBorrowerSingppass?user_id=${user}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      console.log(json);
      let allSingpassData = [json.singpass_data];
      setDataSingpassModal(true);
      if (other_authorization) {
        console.log("need other authorizer");
        setNeedOtherAuthoriser(true);
        try {
          const response2 = await fetch(
            `https://www.smart-lend.com/api/loanDetails/getLoanAuthorisers`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({ loan_id: loan_id }),
            }
          );

          const json2 = await response2.json();
          setOtherAuthoriserDetails(json2.authorisers);
          console.log(JSON.parse(json2.authorisers[0].singpass_data));
          console.log(json.singpass_data);
          setLiveUserData(json.singpass_data);
          console.log(json2.authorisers);

          for (const single of json2.authorisers) {
            allSingpassData.push(JSON.parse(single.singpass_data));
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log("Doesnt need other authoriser");
        setLiveUserData(json.singpass_data);
        setNeedOtherAuthoriser(false);
        setOtherAuthoriserDetails(null);
      }
      if (json.singpass_data) {
        setSingpassData(json.singpass_data);
        console.log(allSingpassData);
        setCombinedSingpassData(allSingpassData);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getShareholderAddress = (data) => {
    const allSingpassData = [singpassData];
    if (otherAuthoriserDetails !== null && otherAuthoriserDetails.length > 0) {
      for (const single of otherAuthoriserDetails) {
        allSingpassData.push(JSON.parse(single.singpass_data));
      }
      const toPush = allSingpassData.filter(
        (sd) => getPersonData(sd)?.name?.value === data
      );
      // console.log(toPush);
      return toPush;
    } else {
      return allSingpassData;
    }
  };

  const getEmployee = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/getEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json();
      setEmployeeList(json.employees);
    } catch (error) {
      console.error(error);
    }
  };

  const changeLoanEmployee = async (loan_id, employee) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/pendingLoan/changeLoanEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loan_id, employee: employee }),
        }
      );
      const json = await response.json();
      if (response.status === 200) {
        const employeeIndex = employeeList.findIndex((emp) =>
          emp.created_users.some((use) =>
            use.loans.some((loa) => loa.loan_id === loan_id)
          )
        );
        console.log(employeeIndex);
        if (employeeIndex > -1) {
          const createdUserIndex = employeeList[
            employeeIndex
          ].created_users.findIndex((use) =>
            use.loans.some((loa) => loa.loan_id === loan_id)
          );
          console.log(createdUserIndex);
          if (createdUserIndex > -1) {
            const loanIndex = employeeList[employeeIndex].created_users[
              createdUserIndex
            ].loans.findIndex((loa) => loa.loan_id === loan_id);
            console.log(loanIndex);
            if (loanIndex > -1) {
              const updatingloansinemployeestatus = [...employeeList];
              updatingloansinemployeestatus[employeeIndex].created_users[
                createdUserIndex
              ].loans[loanIndex].employee = employee ? 1 : 0;

              const clickedUserLoanIndex = clickedUser.loans.findIndex(
                (loa) => loa.loan_id === loan_id
              );

              if (clickedUserLoanIndex > -1) {
                const updatingCLickedUser = { ...clickedUser };
                updatingCLickedUser.loans[clickedUserLoanIndex].employee =
                  employee ? 1 : 0;
                setClickedUser(updatingCLickedUser);
              }

              if (
                updatingloansinemployeestatus[employeeIndex].created_users[
                  createdUserIndex
                ].loans[loanIndex].employee
              ) {
                message.success("Loan request hidden from market place!");
              } else {
                message.success("Loan request pushed to market place!");
                if (
                  updatingloansinemployeestatus[employeeIndex].created_users[
                    createdUserIndex
                  ].loans[loanIndex].make_hidden
                ) {
                  message.warning(
                    "Loan is still hidden as user has withdrawn the loan."
                  );
                }
                if (
                  !updatingloansinemployeestatus[employeeIndex].created_users[
                    createdUserIndex
                  ].loans[loanIndex].visibility &&
                  updatingloansinemployeestatus[employeeIndex].created_users[
                    createdUserIndex
                  ].loans[loanIndex].corporate_structure
                ) {
                  message.warning(
                    "Loan is currently hidden and can be due to it's corporate structure, head over to corporate structure to ensure loan has also been pushed there."
                  );
                }
              }
              setEmployeeList(updatingloansinemployeestatus);
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const createEmployee = async () => {
    try {
      setCreateEmployeeModalIsOpen(false);
      setCreateForm("");
      setCreateEmail("");
      setCreateMobileNo("");
      setCreateRole("employee");
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/createEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: createForm,
            role: createRole,
            email: createEmail.trim() || null,
            mobile_no: createMobileNo.trim() || null,
          }),
        }
      );
      const json = await response.json();
      setEmployeeList(json.all_employees);
    } catch (error) {
      console.error(error);
    }
  };

  const updateEmployeeRole = async () => {
    if (!editingRoleEmployee) return;
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/updateEmployeeRole`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: editingRoleEmployee.id, role: selectedRole }),
        }
      );
      if (response.ok) {
        const json = await response.json();
        setEmployeeList(json.all_employees);
        message.success("Employee role updated!");
        setEditingRoleEmployee(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updateEmployeePassword = async () => {
    if (!passwordEmployee || passwordValue.trim() === "") {
      message.error("Please enter a password.");
      return;
    }
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/updateEmployeePassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: passwordEmployee.id,
            passwordd: passwordValue,
          }),
        }
      );
      if (response.ok) {
        const json = await response.json();
        setEmployeeList(json.all_employees);
        message.success("Employee password updated!");
        setPasswordEmployee(null);
        setPasswordValue("");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const updateEmployeeContact = async () => {
    if (!contactEmployee) return;
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/updateEmployeeContact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: contactEmployee.id,
            email: contactEmail.trim() || null,
            mobile_no: contactMobileNo.trim() || null,
          }),
        }
      );
      if (response.ok) {
        const json = await response.json();
        setEmployeeList(json.all_employees);
        message.success("Employee contact updated!");
        setContactEmployee(null);
        setContactEmail("");
        setContactMobileNo("");
      } else {
        message.error("Unable to update employee contact.");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const deleteEmployee = async (empid) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/deleteEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: empid }),
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        setEmployeeList(json.all_employees);
        message.success("Employee succesfully deleted!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    <div
      style={{
        height: "calc(100% - 80px)",
        width: "calc(100% - 40px)",
        marginLeft: "20px",
        background: "red",
        background:
          "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
        padding: "20px",
        borderRadius: "10px",
        marginTop: "5px",
        gap: "5px",
        color: "black",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Modal
        width="40%"
        footer={null}
        open={createEmployeeModalIsOpen}
        zIndex={800}
        onCancel={() => {
          setCreateEmployeeModalIsOpen(false);
          setCreateForm("");
          setCreateEmail("");
          setCreateMobileNo("");
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (createForm !== "") {
              console.log(createForm);
              createEmployee();
            }
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
            }}
          >
            Create Employee Form
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <input
              value={createForm}
              onChange={(e) => {
                setCreateForm(e.target.value);
              }}
              style={{
                padding: "7px 9px",
                border: "1px solid lightgrey",
              }}
              placeholder="Employee Name"
            />
            <input
              value={createEmail}
              onChange={(e) => {
                setCreateEmail(e.target.value);
              }}
              style={{
                padding: "7px 9px",
                border: "1px solid lightgrey",
                marginTop: "8px",
              }}
              placeholder="Employee Email"
              type="email"
            />
            <input
              value={createMobileNo}
              onChange={(e) => {
                setCreateMobileNo(e.target.value);
              }}
              style={{
                padding: "7px 9px",
                border: "1px solid lightgrey",
                marginTop: "8px",
              }}
              placeholder="Employee Mobile Number"
            />
            <select
              value={createRole}
              onChange={(e) => setCreateRole(e.target.value)}
              style={{
                padding: "7px 9px",
                border: "1px solid lightgrey",
                marginTop: "8px",
              }}
            >
              <option value="employee">Operations</option>
              <option value="customer_support">Customer Support</option>
            </select>
            <button
              type="submit"
              style={{
                background: "rgb(17, 92, 166)",
                color: "white",
                padding: "7px 30px",
                border: "none",
                marginTop: "10px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Create
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        width="40%"
        footer={null}
        open={editingRoleEmployee !== null}
        zIndex={800}
        onCancel={() => {
          setEditingRoleEmployee(null);
        }}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "20px",
            fontFamily: "Manrope,sans-serif",
            fontWeight: 800,
            marginBottom: "10px",
          }}
        >
          Update Employee Role
        </div>
        <div style={{ marginBottom: "10px" }}>
          Changing role for <strong>{editingRoleEmployee?.name}</strong>
        </div>
        <select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          style={{
            padding: "7px 9px",
            border: "1px solid lightgrey",
            width: "100%",
          }}
        >
          <option value="employee">Operations</option>
          <option value="customer_support">Customer Support</option>
        </select>
        <div style={{ marginTop: "12px", display: "flex", gap: 8 }}>
          <button
            onClick={() => setEditingRoleEmployee(null)}
            style={{
              background: "#f0f0f0",
              color: "#142C44CC",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => updateEmployeeRole()}
            style={{
              background: "rgb(17, 92, 166)",
              color: "white",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Update Role
          </button>
        </div>
      </Modal>
      <Modal
        width="40%"
        footer={null}
        open={passwordEmployee !== null}
        zIndex={800}
        onCancel={() => {
          setPasswordEmployee(null);
          setPasswordValue("");
        }}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "20px",
            fontFamily: "Manrope,sans-serif",
            fontWeight: 800,
            marginBottom: "10px",
          }}
        >
          Set Employee Password
        </div>
        <div style={{ marginBottom: "10px" }}>
          Setting password for <strong>{passwordEmployee?.name}</strong>
        </div>
        <input
          type="password"
          value={passwordValue}
          onChange={(e) => setPasswordValue(e.target.value)}
          style={{
            padding: "7px 9px",
            border: "1px solid lightgrey",
            width: "100%",
          }}
          placeholder="Enter new password"
        />
        <div style={{ marginTop: "12px", display: "flex", gap: 8 }}>
          <button
            onClick={() => {
              setPasswordEmployee(null);
              setPasswordValue("");
            }}
            style={{
              background: "#f0f0f0",
              color: "#142C44CC",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => updateEmployeePassword()}
            style={{
              background: "rgb(17, 92, 166)",
              color: "white",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Update Password
          </button>
        </div>
      </Modal>
      <Modal
        width="40%"
        footer={null}
        open={contactEmployee !== null}
        zIndex={800}
        onCancel={() => {
          setContactEmployee(null);
          setContactEmail("");
          setContactMobileNo("");
        }}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "20px",
            fontFamily: "Manrope,sans-serif",
            fontWeight: 800,
            marginBottom: "10px",
          }}
        >
          Update Employee Contact
        </div>
        <div style={{ marginBottom: "10px" }}>
          Updating contact for <strong>{contactEmployee?.name}</strong>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <input
            type="email"
            value={contactEmail}
            onChange={(e) => setContactEmail(e.target.value)}
            placeholder="Employee Email"
            style={{
              padding: "7px 9px",
              border: "1px solid lightgrey",
              width: "100%",
            }}
          />
          <input
            value={contactMobileNo}
            onChange={(e) => setContactMobileNo(e.target.value)}
            placeholder="Employee Mobile Number"
            style={{
              padding: "7px 9px",
              border: "1px solid lightgrey",
              width: "100%",
            }}
          />
        </div>
        <div style={{ marginTop: "12px", display: "flex", gap: 8 }}>
          <button
            onClick={() => {
              setContactEmployee(null);
              setContactEmail("");
              setContactMobileNo("");
            }}
            style={{
              background: "#f0f0f0",
              color: "#142C44CC",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => updateEmployeeContact()}
            style={{
              background: "rgb(17, 92, 166)",
              color: "white",
              padding: "7px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Update Contact
          </button>
        </div>
      </Modal>
      <Modal
        width="80%"
        zIndex={800}
        footer={null}
        open={showingAccounts !== false}
        onCancel={() => {
          setShowingAccounts(false);
        }}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "20px",
            fontFamily: "Manrope,sans-serif",
            fontWeight: 800,
          }}
        >
          Accounts registered by {showingAccounts.name}
        </div>
        <div
          style={{
            background: "rgba(17, 92, 166, 0.2)",
            padding: "10px 0px 0px 0px",
            borderRadius: 8,
            marginTop: 10,
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
              fontSize: 16,
              display: "flex",
              gap: 10,
              marginBottom: "10px",
            }}
          >
            <div style={{ width: "90px", paddingLeft: "10px" }}>ID</div>
            <div style={{ width: "250px" }}>Email</div>
            <div style={{ width: "250px" }}>Entity</div>
            <div style={{ width: "250px" }}>Principal</div>
            <div style={{ width: "150px" }}>Request</div>
            <div style={{ width: "200px" }}>Registration Date</div>
          </div>
          <div>
            {showingAccounts ? (
              showingAccounts.created_users.length > 0 ? (
                showingAccounts.created_users.map((userr, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setClickedUser(userr);
                    }}
                    style={{
                      background:
                        index % 2 ? "rgba(17, 92, 166, 0.02)" : "white",
                      color: "#142C44CC",
                      fontFamily: "Manrope,sans-serif",
                      fontWeight: 500,
                      fontSize: 12,
                      display: "flex",
                      gap: 10,
                      padding: "7px 0px",
                      cursor: "pointer",
                    }}
                    className="row_click"
                  >
                    <div style={{ width: "90px", paddingLeft: "10px" }}>
                      {userr.user.user_id}
                    </div>
                    <div style={{ width: "250px" }}>{userr.user.email}</div>
                    <div style={{ width: "250px" }}>
                      {userr.user.entity_name}
                    </div>
                    <div style={{ width: "250px" }}>
                      {userr.user.principal_name}
                    </div>
                    <div style={{ width: "150px" }}>{userr.loans.length}</div>
                    <div style={{ width: "200px" }}>
                      {formatDate(new Date(userr.user.created_at))}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "white",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <BrokenImageIcon
                      style={{ fontSize: 80, color: "lightgrey" }}
                    />
                    <div style={{ color: "grey" }}>There is no data found</div>
                  </div>
                </div>
              )
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "400px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BrokenImageIcon
                    style={{ fontSize: 80, color: "lightgrey" }}
                  />
                  <div style={{ color: "grey" }}>There is no data found</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
      {clickedUser ? (
        <Modal
          width="1200px"
          style={{ zIndex: 900 }}
          zIndex={900}
          footer={null}
          open={clickedUser !== null}
          onCancel={() => {
            setClickedUser(null);
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
            }}
          >
            Loan request by {clickedUser.user.entity_name}
          </div>
          <div
            style={{
              background: "rgba(17, 92, 166, 0.2)",
              padding: "10px 0px 0px 0px",
              borderRadius: 8,
              marginTop: 10,
            }}
          >
            <div
              style={{
                color: "#142C44CC",
                fontSize: "20px",
                fontFamily: "Manrope,sans-serif",
                fontWeight: 800,
                fontSize: 16,
                display: "flex",
                gap: 10,
                marginBottom: "10px",
              }}
            >
              <div style={{ width: "90px", paddingLeft: "10px" }}>ID</div>
              <div style={{ width: "250px" }}>Request Amount</div>
              <div style={{ width: "100px" }}>Interest</div>
              <div style={{ width: "100px" }}>P.Fee</div>
              <div style={{ width: "100px" }}>Period</div>
              <div style={{ width: "200px" }}>Bank Sta.</div>
              <div style={{ width: "200px" }}>Overwrite.</div>
            </div>
            <div>
              {clickedUser ? (
                clickedUser.loans.length > 0 ? (
                  clickedUser.loans.map((loan, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setBadgeVerified(clickedUser.user.badge_verified);
                        setBackupContact(loan.user_id);

                        const dataToPush = [
                          {
                            name: getPersonData(JSON.parse(clickedUser.user.singpass_data))?.name?.value,
                            cbs_data: JSON.parse(
                              clickedUser.user.credit_report_data
                            ),
                          },
                        ];
                        for (const dat of loan.loan_authorizations) {
                          dataToPush.push({
                            name: dat.director_name,
                            cbs_data: JSON.parse(dat.credit_report_data),
                          });
                        }
                        console.log(loan);
                        setAllCBSData(dataToPush);

                        singpassDetails(
                          loan.user_id,
                          loan.authorization_required,
                          loan.loan_id,
                          loan.keyman
                        );
                      }}
                      style={{
                        background:
                          index % 2 ? "rgba(17, 92, 166, 0.02)" : "white",
                        color: "#142C44CC",
                        fontFamily: "Manrope,sans-serif",
                        fontWeight: 500,
                        fontSize: 12,
                        display: "flex",
                        gap: 10,
                        padding: "7px 0px",
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      className="row_click"
                    >
                      <div style={{ width: "90px", paddingLeft: "10px" }}>
                        {loan?.loan_id}
                      </div>
                      <div style={{ width: "250px" }}>
                        {loan?.request_amount.toLocaleString("en-US", {
                          style: "currency",
                          currency: "SGD",
                        })}
                      </div>
                      <div style={{ width: "100px" }}>
                        {(loan?.request_interest_rate * 100).toFixed(1) + " %"}
                      </div>
                      <div style={{ width: "100px" }}>
                        {(loan?.admin_fee * 100).toFixed(1) + " %"}
                      </div>
                      <div style={{ width: "100px" }}>
                        {loan?.request_period + " months"}
                      </div>
                      <div style={{ width: "200px", display: "flex" }}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(loan?.bank_statement);
                          }}
                          style={{
                            background: "rgb(17, 92, 166)",
                            color: "white",
                            padding: "7px 30px",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        >
                          Download
                        </div>
                      </div>
                      <div style={{ width: "200px", display: "flex" }}>
                        {loan?.employee ? (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              changeLoanEmployee(loan?.loan_id, false);
                            }}
                            style={{
                              background: "rgb(17, 92, 166)",
                              color: "white",
                              padding: "7px 30px",
                              border: "none",
                              borderRadius: "8px",
                              cursor: "pointer",
                            }}
                          >
                            Push
                          </div>
                        ) : (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              changeLoanEmployee(loan?.loan_id, true);
                            }}
                            style={{
                              background: "rgb(17, 92, 166)",
                              color: "white",
                              padding: "7px 30px",
                              border: "none",
                              borderRadius: "8px",
                              cursor: "pointer",
                            }}
                          >
                            Hide
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "400px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "white",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BrokenImageIcon
                        style={{ fontSize: 80, color: "lightgrey" }}
                      />
                      <div style={{ color: "grey" }}>
                        There is no data found
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "white",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <BrokenImageIcon
                      style={{ fontSize: 80, color: "lightgrey" }}
                    />
                    <div style={{ color: "grey" }}>There is no data found</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>
      ) : null}

      <Modal
        width={isMobile ? "100%" : "60%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)", zIndex: 1000 }}
        zIndex={1000}
        open={dataSingpassModal}
        onCancel={() => {
          setDataSingpassModal(false);
          setSingpassData(null);
          setOpenDataIndex(null);
          setKeyman("");
        }}
        footer={null}
      >
        {singpassData ? (
          <ProfileViewer
            keyman={keyman}
            isMobile={isMobile}
            viewingUser={viewingUser}
            setViewingUser={(data) => {
              setViewingUser(data);
            }}
            singpassData={singpassData}
            liveUserData={liveUserData}
            otherAuthoriserDetails={otherAuthoriserDetails}
            setLiveUserData={(data) => {
              setLiveUserData(data);
            }}
            setViewingTab={(data) => {
              setViewingTab(data);
            }}
            viewingTab={viewingTab}
            badgeVerified={badgeVerified}
            availableTab={availableTab}
            allCBSData={allCBSData}
            combinedSingpassData={combinedSingpassData}
            getShareholderAddress={(data) => {
              getShareholderAddress(data);
            }}
            backupContact={backupContact}
          />
        ) : (
          <div></div>
        )}
      </Modal>
      <div style={{ width: "100%", marginBottom: "15px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
            }}
          >
            Employee list
          </div>
        </div>
        <div>
          Click on any of the employee below to copy employee sign up link.
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-start", gap: 20 }}>
        <div
          style={{ background: "white", padding: "10px 0px", borderRadius: 8 }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "20px",
              fontFamily: "Manrope,sans-serif",
              fontWeight: 800,
              fontSize: 16,
              display: "flex",
              gap: 10,
              marginBottom: "10px",
            }}
          >
            <div style={{ width: "50px", paddingLeft: "10px" }}>ID</div>
            <div style={{ width: "180px" }}>Name</div>
            <div style={{ width: "220px" }}>Email</div>
            <div style={{ width: "150px" }}>Mobile</div>
            <div style={{ width: "140px" }}>Role</div>
            <div style={{ width: "360px" }}>Link</div>
            <div style={{ width: "100px" }}>Accounts</div>
            <div style={{ width: "260px" }}>Action</div>
          </div>
          {employeeList ? (
            employeeList.length > 0 ? (
              employeeList.map((emp, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setShowingAccounts(emp);
                  }}
                  style={{
                    background: index % 2 ? "white" : "rgba(17, 92, 166, 0.1)",
                    color: "#142C44CC",
                    fontFamily: "Manrope,sans-serif",
                    fontWeight: 500,
                    fontSize: 12,
                    display: "flex",
                    gap: 10,
                    padding: "7px 0px",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ width: "50px", paddingLeft: "10px" }}>
                    {emp.id}
                  </div>
                  <div style={{ width: "180px" }}>{emp.name}</div>
                  <div style={{ width: "220px" }}>{emp.email || "-"}</div>
                  <div style={{ width: "150px" }}>{emp.mobile_no || "-"}</div>
                  <div style={{ width: "140px" }}>
                    {emp.role === "customer_support"
                      ? "Customer Support"
                      : "Operations"}
                  </div>
                  <div
                    style={{ width: "360px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const textToCopy =
                        "https://smart-lend.com/auth/signup?ecid=" + emp.id;
                      navigator.clipboard
                        .writeText(textToCopy)
                        .then(() => {
                          message.success("link copied to clipboard!");
                        })
                        .catch((err) => {
                          console.error("Failed to copy text: ", err);
                        });
                      }}
                    >
                      {"https://smart-lend.com/auth/signup?ecid=" + emp.id}
                    </div>
                  <div style={{ width: "100px" }}>
                    {emp.created_users?.length}
                  </div>
                  <div
                    style={{
                      width: "260px",
                      display: "flex",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setEditingRoleEmployee(emp);
                        setSelectedRole(emp.role || "employee");
                      }}
                      style={{
                        background: "#0f7c2f",
                        color: "white",
                        padding: "5px 10px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      Change Role
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setPasswordEmployee(emp);
                        setPasswordValue("");
                      }}
                      style={{
                        background: "#f59e0b",
                        color: "white",
                        padding: "5px 10px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      Set Password
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setContactEmployee(emp);
                        setContactEmail(emp.email || "");
                        setContactMobileNo(emp.mobile_no || "");
                      }}
                      style={{
                        background: "#2563eb",
                        color: "white",
                        padding: "5px 10px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      Set Contact
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        deleteEmployee(emp.id);
                      }}
                      style={{
                        background: "rgb(17, 92, 166)",
                        color: "white",
                        padding: "5px 10px",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "400px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BrokenImageIcon
                    style={{ fontSize: 80, color: "lightgrey" }}
                  />
                  <div style={{ color: "grey" }}>
                    There is currently no employee registered
                  </div>
                </div>
              </div>
            )
          ) : (
            <div
              style={{
                width: "100%",
                height: "400px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BrokenImageIcon style={{ fontSize: 80, color: "lightgrey" }} />
                <div style={{ color: "grey" }}>
                  There is currently no employee registered
                </div>
              </div>
            </div>
          )}
          <button
            onClick={(e) => {
              e.preventDefault();
              setCreateEmployeeModalIsOpen(true);
            }}
            style={{
              background: "rgb(17, 92, 166)",
              color: "white",
              padding: "7px 30px",
              border: "none",
              marginTop: "10px",
              borderRadius: "8px",
              cursor: "pointer",
              marginLeft: 10,
            }}
          >
            Create
          </button>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default EmployeeSetup;
